const MULTIPLIER = 1024;
export const getObjectSizeInBytes = (obj, unit = "kb") => {
    let str = null;
    if (typeof obj === "string") {
        // If obj is a string, then use it
        str = obj;
    }
    else {
        // Else, make obj into a string
        str = JSON.stringify(obj);
    }
    // Getting a rough size of it in byte
    const bytes = new Blob([str]).size;
    if (unit === "kb") {
        return bytes / MULTIPLIER;
    }
    else if (unit === "mb") {
        return bytes / MULTIPLIER / MULTIPLIER;
    }
    return bytes;
};
//# sourceMappingURL=getObjectSizeInBytes.js.map